// 示例 store 模块，演示如何按照 key.split("_")[2] : result 格式存储数据

// 默认状态
const state = {
  // 存储以键值对形式的数据
  answers: {},
  currentDataTemp: {},
  // 记录已替换的资源ID映射关系，oldId -> newId
  replacedResources: null,
};

// mutation 用于修改状态
const mutations = {
  // 添加单条数据
  ADD_ANSWER(state, { key, result }) {
    // 从键中提取标识符作为新的键
    // 假设 key 的格式类似于 "question_type_123"，我们取 "123" 作为新键
    const newKey = key.split("_")[2];
    // 设置新的键值对
    state.answers = {
      ...state.answers,
      [newKey]: result
    };
  },
  
  // 批量添加数据
  ADD_ANSWERS(state, dataList) {
    // dataList 是一个包含 {key, result} 对象的数组
    const newData = {};
    dataList.forEach(({ key, result }) => {
      const newKey = key.split("_")[2];
      newData[newKey] = result;
    });
    
    // 合并到现有数据
    state.answers = {
      ...state.answers,
      ...newData
    };
  },
  
  // 清除数据
  CLEAR_ANSWERS(state) {
    state.answers = {};
  },
  SET_CURRENT_DATA_TEMP(state, data) {
    state.currentDataTemp = data;
  },
  // 初始化替换资源记录
  INIT_REPLACED_RESOURCES(state) {
    if (!state.replacedResources) {
      state.replacedResources = {};
    }
  },
  // 添加替换资源记录
  ADD_REPLACED_RESOURCE(state, { oldId, newId }) {
    if (!state.replacedResources) {
      state.replacedResources = {};
    }
    state.replacedResources[oldId] = newId;
    console.log("替换资源ID记录更新:", state.replacedResources);
  },
};

// action 用于处理异步操作
const actions = {
  // 异步添加数据示例
  addAnswerAsync({ commit }, { key, result }) {
    return new Promise((resolve) => {
      setTimeout(() => {
        commit('ADD_ANSWER', { key, result });
        resolve();
      }, 100);
    });
  }
};

// getter 用于获取状态
const getters = {
  // 获取所有数据
  allAnswers: (state) => state.answers,
  
  // 获取特定 ID 的数据
  getAnswerById: (state) => (id) => {
    return state.answers[id] || null;
  },
  
  // 获取数据总数
  answersCount: (state) => {
    return Object.keys(state.answers).length;
  },
  currentDataTemp: (state) => state.currentDataTemp,
  // 获取替换资源记录
  replacedResources: (state) => state.replacedResources,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}; 